import BaseImage from "@/app/(site)/_components/Atoms/BaseImage"
import IconArrowRight from "@/app/(site)/_components/Atoms/Icons/IconArrowRight"
import StoryText from "@/app/(site)/_components/Atoms/Storytext"
import Text from "@/app/(site)/_components/Atoms/Text"
import ButtonText from "@/app/(site)/_components/Molecules/ButtonText"
import DynamicLink from "@/app/(site)/_components/Molecules/Link"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"
import { RelatedArticles } from "@/types"

export default function ArticleCard({
    article,
    index,
    locale
}: {
    article: RelatedArticles
    index: number
    locale: string
}) {
    const isPressroom = article?.preSlug === "pressroom/"
    const pressromPageArticle = article._type === "pressroomArticle"
    const datePublished = article.articleCreationDate
    const formattedDate = datePublished
        ? new Date(datePublished).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
          })
        : null
    const language = getLangCode(locale) || "en"
    return (
        <article key={index} className="overflow-hidden">
            {article.image?.asset && (
                <DynamicLink
                    href={article?.slug ? `/${article?.preSlug}${article.slug}` : ""}
                    aria-label={`Read more about ${article?.pageHeading}`}
                    prefetch={false}
                >
                    <figure
                        className={`w-full ${article?.image?.squareImage ? "aspect-square" : "aspect-[3/4]"} relative`}
                    >
                        <BaseImage
                            className={`object-cover`}
                            alt={
                                article?.image?.alt
                                    ? article?.image?.alt
                                    : "Journal article image"
                            }
                            asset={article.image?.asset}
                            src={article.image?.asset?._ref || ""}
                            mimeType={article.image?.asset?.mimeType}
                            fill
                            loading="lazy"
                        />
                        {article?.image?.alt && (
                            <figcaption className="sr-only">
                                {article?.image?.alt}
                            </figcaption>
                        )}
                    </figure>
                </DynamicLink>
            )}
            <div className="mt-24 flex flex-col">
                <DynamicLink
                    href={article?.slug ? `/${article?.preSlug}${article.slug}` : ""}
                    aria-label={`Read more about ${article?.pageHeading}`}
                >
                    <StoryText size="size2">{article?.pageHeading}</StoryText>
                </DynamicLink>
                {isPressroom && datePublished && (
                    <Text weight="regular" size="small" className="text-main-dark-grey">
                        {formattedDate}
                    </Text>
                )}
                {!pressromPageArticle && (
                    <StoryText size="size4">{article?.articlePreviewText}</StoryText>
                )}
            </div>
            <DynamicLink
                href={article?.slug ? `/${article?.preSlug}${article.slug}` : ""}
                aria-label={`Read more about ${article?.pageHeading}`}
                prefetch={false}
            >
                <ButtonText
                    size="big"
                    icon={<IconArrowRight className="h-16 w-16" />}
                    iconPosition="right"
                    className="flex items-center gap-4 p-14 pl-0"
                >
                    {t(language, "READ MORE")}
                </ButtonText>
            </DynamicLink>
        </article>
    )
}
